import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Buro from '../../assets/home/buro.png';

function BuroLogo() {
  const buroName = 'Información del Buró de Entidades Financieras';
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      width={{ xs: '50%', sm: '75%', md: '70%' }}
      alignItems="flex-start"
      spacing={1}
      marginTop={0.5}
    >
      <Box
        component="img"
        src={Buro}
        alt=""
        sx={{
          maxHeight: 80,
          maxWidth: 'auto',
          objectFit: 'contain',
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'scale(1.05)',
            cursor: 'pointer',
          },
        }}
        onClick={() => {
          navigate('/help/buro-info');
        }}
      />
      <Typography
        variant="small_2"
        color={theme.palette.neutral.A400}
        fontWeight={500}
        justifyContent="center"
        textAlign="left"
      >
        {buroName}
      </Typography>
    </Stack>
  );
}

export default BuroLogo;
